import axios from 'axios';

const addBar = async (client_id) => {
    try {
        const token = localStorage.getItem('token'); // Substituindo AsyncStorage por localStorage
        if (!token) {
            return {
                success: false,
                error: 'Usuário não autenticado.'
            };
        }

        const response = await axios.post(
            'https://apem.riderup.uk/api/addBar',
            { client_id },
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        );

        if (response.status === 200) {
            return {
                success: true,
                message: response.data.message
            };
        } else {
            return {
                success: false,
                error: response.data.message || 'Erro ao adicionar Bar.'
            };
        }
    } catch (error) {
        console.error('Erro ao adicionar Bar:', error);
        return {
            success: false,
            error: error.response?.data?.message || 'Erro ao conectar com a API.'
        };
    }
};

export default addBar;
